// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__NWBA1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1cs0n"};